<template>
  <div class="buffering">
    <div class="buffering-inner">
      <div class="loader-wrap">
        <div class="loader-ring" />
        <div class="loader-ring ring2" />
        <div class="loader-core">Ψ</div>
      </div>

      <h2>Generating Your Personal Report</h2>
      <p class="loading-text">{{ currentMessage }}</p>

      <div class="loading-dots">
        <span /><span /><span />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BufferingPage',
  data () {
    return {
      messages: [
        'Connecting to global normative database...',
        'Calibrating cognitive bias via behavioral economics models...',
        'Running structured scoring logic...',
        'Matching multi-dimensional report template...',
        'Generating your personalized assessment report...'
      ],
      messageIndex: 0,
      timer: null
    }
  },
  computed: {
    currentMessage () {
      return this.messages[this.messageIndex]
    }
  },
  mounted () {
    this.timer = setInterval(() => {
      this.messageIndex = (this.messageIndex + 1) % this.messages.length
    }, 900)
  },
  beforeDestroy () {
    if (this.timer) clearInterval(this.timer)
  }
}
</script>

<style scoped>
.buffering {
  min-height: 80vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, #0d1f3c 0%, #1a3a6b 50%, #0d1f3c 100%);
  padding: 3rem 1.5rem;
}

.buffering-inner {
  text-align: center;
  max-width: 760px;
  width: 100%;
}

.loader-wrap {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 2rem;
}

.loader-ring {
  position: absolute;
  inset: 0;
  border: 3px solid rgba(232,197,71,0.15);
  border-top-color: #e8c547;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.ring2 {
  inset: 10px;
  border-top-color: rgba(255,255,255,0.4);
  animation-duration: 1.5s;
  animation-direction: reverse;
}

.loader-core {
  position: absolute;
  inset: 25px;
  background: rgba(232,197,71,0.15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: #e8c547;
  font-family: 'Playfair Display', serif;
  animation: pulse 1.5s ease infinite;
}

.buffering h2 {
  font-family: 'Playfair Display', serif;
  font-size: 1.6rem;
  color: #fff;
  margin-bottom: 0.75rem;
}

.loading-text {
  color: rgba(255,255,255,0.65);
  font-size: 0.95rem;
  min-height: 1.5rem;
  margin-bottom: 1.5rem;
  transition: opacity 0.3s;
}

.loading-dots {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
}

.loading-dots span {
  width: 8px;
  height: 8px;
  background: #e8c547;
  border-radius: 50%;
  animation: bounce 1.2s ease infinite;
}

.loading-dots span:nth-child(2) { animation-delay: 0.2s; }
.loading-dots span:nth-child(3) { animation-delay: 0.4s; }

@keyframes bounce {
  0%, 80%, 100% { transform: scale(0.6); opacity: 0.4; }
  40% { transform: scale(1); opacity: 1; }
}
</style>
